module.exports = __webpack_public_path__ + "static/media/folder.2396431c.svg";